import React, { useState } from 'react';

import Input from '../../../../components/inputs/Input';
import { OrderForm } from './transformToEditOrderRequestObject';
import { OrderPackageSize } from '../../../../types/orderTypes';

interface EditPackageInfoProps {
  orderForm: OrderForm;
  updateOrderForm: (o: Partial<OrderForm>) => void;
}

export const EditPackageInfo = ({
  orderForm,
  updateOrderForm,
}: EditPackageInfoProps) => {
  const [packageCount, setPackageCount] = useState<string>(
    orderForm.packageCount ? orderForm.packageCount.toString() : ''
  );

  const onPackageCountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPackageCount(event.target.value);

    if (!isNaN(parseInt(event.target.value, 10))) {
      updateOrderForm({ packageCount: parseInt(event.target.value, 10) });
    }
  };

  return (
    <div className="information__box">
      <span className="box__field">
        <h5>Delivery type: </h5>
        <div className="selector">
          <div
            className={orderForm.type === 'Express' ? '' : 'selected'}
            onClick={() => {
              updateOrderForm({ type: 'Scheduled' });
            }}
          >
            Scheduled
          </div>
          <div
            className={orderForm.type === 'Express' ? 'selected' : ''}
            onClick={() => {
              updateOrderForm({ type: 'Express' });
            }}
          >
            Express
          </div>
        </div>
      </span>
      <span className="box__field">
        <h5>Package size:</h5>
        <div className="selector">
          <div
            className={
              orderForm.packageSize === OrderPackageSize.Small ? 'selected' : ''
            }
            onClick={() => {
              updateOrderForm({ packageSize: OrderPackageSize.Small });
            }}
          >
            Small
          </div>
          <div
            className={
              orderForm.packageSize === OrderPackageSize.Medium
                ? 'selected'
                : ''
            }
            onClick={() => {
              updateOrderForm({ packageSize: OrderPackageSize.Medium });
            }}
          >
            Medium
          </div>
          <div
            className={
              orderForm.packageSize === OrderPackageSize.Large ? 'selected' : ''
            }
            onClick={() => {
              updateOrderForm({ packageSize: OrderPackageSize.Large });
            }}
          >
            Large
          </div>
          <div
            className={
              orderForm.packageSize === OrderPackageSize.Xxl ? 'selected' : ''
            }
            onClick={() => {
              updateOrderForm({ packageSize: OrderPackageSize.Xxl });
            }}
          >
            XXL
          </div>
        </div>
      </span>
      <span className="box__field">
        <h5>Package count:</h5>
        <div style={{ maxWidth: 50 }}>
          <Input value={packageCount} onChange={onPackageCountChange} />
        </div>
      </span>
    </div>
  );
};
